// frontend/src/components/landing/sections/CtaBand.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Container, Glow, LandingButton, Reveal } from '../parts';
import { tokens } from '../landingTheme';

// Focal point 2 of 2: a navy panel with one warm glow
const CtaBand = () => (
    <Box component="section" aria-labelledby="cta-title" sx={{ pb: { xs: 10, md: 16 } }}>
        <Container>
            <Reveal
                sx={{
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: 10,
                    bgcolor: tokens.accent,
                    color: '#FFFFFF',
                    px: { xs: 3, sm: 6, md: 10 },
                    py: { xs: 10, md: 15 },
                    textAlign: 'center',
                    boxShadow: tokens.shadowLift,
                }}
            >
                <Glow dark />
                <Box sx={{ position: 'relative', maxWidth: 760, mx: 'auto' }}>
                    <Typography id="cta-title" variant="h2" component="h2" sx={{ color: '#FFFFFF', fontSize: { md: '4rem' } }}>
                        Bring classroom talk into focus.
                    </Typography>
                    <Typography variant="subtitle1" component="p" sx={{ mt: 3, color: 'rgba(255, 255, 255, 0.85)', maxWidth: 520, mx: 'auto' }}>
                        Start with one lesson transcript and see what your classroom conversation looks like.
                    </Typography>
                    <LandingButton variant="inverse" to="/register" sx={{ mt: 5 }} arrow>
                        Analyze a lesson
                    </LandingButton>
                </Box>
            </Reveal>
        </Container>
    </Box>
);

export default CtaBand;
